import axiosInstance from '../../axios/instance'
import { getToken } from '../../helpers/get-token'

async function getSnapshotData(id, inventoryId) {
    try {
        const token = getToken()
        axiosInstance.defaults.headers.common['authorization'] = token
        const response = await axiosInstance.get(process.env.REACT_APP_HUB_URL + '/api/auctions/interval-auctions/snapshot/' + inventoryId + '/' + id)
        return response?.data
    } catch (error) {
        console.log(error)
    }
}

export default getSnapshotData
